<!-- TODO: Mobilná verzia ešte nieje navrhnutá, Kontaktná osoba sa bude prerábať aj pre desktop a potom mobil -->
<template>
  <div>
    <v-container class="pa-0 wizard-najomca">
      <v-form @input="updateFormValid" ref="form" autocomplete="off">
        <debug-control
          @click="log"
          v-if="debug"
          :value="[
            'validationObjectResult',
            'formValid',
            'somethingGetDirty',
            'somethingIsLoading',
            'currentControl',
            'zastupca',
            'pripad',
          ]"
          :parent="this"
        />
        <uvod-banner :isMobile="isMobile" :class="{ 'pb-7 mt-45px': !isMobile }"></uvod-banner>
        <!-- this.validationObjectResult && this.formValid && this.formControlsLoaded -->
        <v-card class="card">
          <h2 class="mb-6">Nájomca</h2>
          <v-row no-gutters>
            <v-col xl="12" lg="12" md="12">
              <uvod-forma
                ref="formaPodn"
                @valueChanged="OnFormaPodnValueChanged"
                :parentReloaded="reloaded"
                :disabled="
                  vytvaranieZakaznikaPrebieha || zastupca.opUploaded || idVytazenia != null
                "
                v-model="formaPodn"
              ></uvod-forma>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="formaPodn === 2">
            <v-col xl="4" lg="4" md="4">
              <check-box
                ref="podnikaNaRc"
                @valueChanged="OnPodnikaNaRcValueChanged"
                :key="formaPodn"
                dataId="liw_filip__wiz_najomca__btn_podnika_na_rc"
                v-model="podnikaNaRc"
                :isEnabled="
                  !vytvaranieZakaznikaPrebieha && !zastupca.opUploaded && idVytazenia == null
                "
              />
            </v-col>
          </v-row>

          <v-row
            class="no-padding-top-bottom"
            v-bind:class="{ 'mt-8': formaPodn != 2 }"
            v-if="formaPodn === 1 || (formaPodn === 2 && !podnikaNaRc)"
          >
            <v-col xl="4" lg="4" md="4">
              <ico
                ref="ico"
                dataId="liw_filip__wiz_najomca__txt_ico_rc"
                v-model="icoObj"
                :formaPodn="formaPodn"
                :isEnabled="icoEnabled && !zastupca.opUploaded && idVytazenia == null"
                placeholder="Identifikačné číslo nájomcu"
                @loading="vytvaranieZakaznikaPrebieha"
                @enabledChanged="val => ($refs.obchodMeno.l_isEnabled = val)"
                @dataLoaded="overKlon"
              ></ico>
            </v-col>
            <v-col xl="4" lg="4" md="4">
              <ico
                ref="obchodMeno"
                placeholder="Obchodné meno nájomcu"
                dataId="liw_filip__wiz_najomca__txt_obch_meno"
                obchodneMeno
                ignore-init
                v-model="icoObj"
                :formaPodn="formaPodn"
                :isEnabled="icoEnabled && !zastupca.opUploaded && idVytazenia == null"
                :loading="vytvaranieZakaznikaPrebieha"
              ></ico>
            </v-col>
          </v-row>

          <v-row class="no-padding-top-bottom" :class="{ 'mt-8': formaPodn === 3 }" v-else>
            <v-col xl="4" lg="4" md="4">
              <text-box
                ref="meno"
                :parentReloaded="reloaded"
                :disabled="zastupca.opUploaded || idVytazenia != null"
                required
                dataId="liw_filip__wiz_najomca__txt_meno"
                @valueChanged="OnMenoValueChanged()"
                placeholder="Meno nájomcu"
              ></text-box>
            </v-col>
            <v-col xl="4" lg="4" md="4">
              <text-box
                ref="priezvisko"
                :disabled="zastupca.opUploaded || idVytazenia != null"
                :parentReloaded="reloaded"
                dataId="liw_filip__wiz_najomca__txt_priezvisko"
                @valueChanged="OnPriezviskoValueChanged()"
                required
                placeholder="Priezvisko nájomcu"
              ></text-box>
            </v-col>
          </v-row>
          <v-row class="no-padding-top-bottom">
            <v-col xl="4" lg="4" md="4">
              <text-box
                ref="email"
                :parentReloaded="reloaded"
                dataId="liw_filip__wiz_najomca__txt_email"
                placeholder="@"
                required
                email
                @input="val => (email = val)"
                @valueChanged="OnEmailValueChanged()"
                :disabled="idVytazenia != null"
              ></text-box>
            </v-col>
            <v-col xl="4" lg="4" md="4">
              <text-box
                ref="telCislo"
                :parentReloaded="reloaded"
                dataId="liw_filip__wiz_najomca__txt_telefon"
                :rules="[telefonneCisloRule]"
                placeholder="+421"
                required
                @input="val => (telefon = val)"
                @valueChanged="getOPBtn()"
                textOnFocus="+421"
                :removeCharacters="/[^+\d]/g"
                :isPhoneNumber="true"
                :disabled="idVytazenia != null"
              ></text-box>
            </v-col>
          </v-row>
          <v-row class="no-padding-top-bottom">
            <v-col xl="4" lg="4" md="4">
              <dynamic-combo
                label="Zdroj ponuky"
                :parentReloaded="reloaded"
                dataId="liw_filip__wiz_najomca__cb_zdroj_ponuky"
                :disabled="idVytazenia != null"
              ></dynamic-combo>
            </v-col>
          </v-row>
        </v-card>

        <!-- ############### -->
        <!-- Kontaktná osoba -->
        <!-- ############### -->
        <!-- TODO: vytvorit progressbar a zobrazit ho pokym nahrava dokument do DMS -->
        <v-card class="mt-6 card">
          <h2 :class="{ 'mb-4': formaPodn === 3 }">Kontaktná osoba</h2>
          <v-row v-show="formaPodn == 1">
            <v-col xl="4" lg="4" md="4">
              <dynamic-combo
                class="mt-6"
                ref="idStatutar"
                label="Štatutár"
                dataId="liw_filip__wiz_kontaktna_osoba__cb_statutari"
                :idZastupcu="pripad.idZastupcu"
                @input="v => (idStatutar = v)"
                @valueChanged="() => this.loadStatutar()"
                :disabled="idVytazenia != null"
              ></dynamic-combo>
            </v-col>
            <v-col xl="4" lg="4" md="4">
              <dynamic-combo
                class="mt-6"
                ref="idFunkcie"
                label="Funkcia"
                dataId="liw_filip__wiz_kontaktna_osoba__cb_funkcie"
                :idZastupcu="pripad.idZastupcu"
                @input="v => (idFunkcie = v)"
                @valueChanged="() => this.$refs.idFunkcie.loadData()"
                :disabled="idVytazenia != null"
              ></dynamic-combo>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              xl="3"
              lg="3"
              md="3"
              v-if="formaPodn == 1 || formaPodn == 2"
              style="height: 70px"
            >
              <check-box
                ref="kuv"
                label="Konečný užívateľ výhod"
                dataId="liw_filip__wiz_kontaktna_osoba__btn_kuv"
                :idZastupcu="pripad.idZastupcu"
                :disabled="idVytazenia != null"
              ></check-box>
            </v-col>
            <v-col xl="3" lg="3" md="3" v-if="formaPodn == 1 || formaPodn == 2">
              <check-box
                ref="jeKonatel"
                label="Štatutárny zástupca"
                dataId="liw_filip__wiz_kontaktna_osoba__btn_je_konatel"
                :idZastupcu="pripad.idZastupcu"
                :disabled="idVytazenia != null"
              ></check-box>
            </v-col>
            <v-col xl="3" lg="3" md="3">
              <check-box
                ref="zahrOsoba"
                label="Zahraničná osoba"
                dataId="liw_filip__wiz_kontaktna_osoba__btn_zahr_osoba"
                :idZastupcu="pripad.idZastupcu"
                @input="v => (zastupca.zahranicnaOsoba = v)"
                @valueChanged="
                  () => {
                    if (this.$refs.rodnePriezvisko) this.$refs.rodnePriezvisko.loadData();
                    this.$refs.obcianstvo.loadData();
                  }
                "
                :parentReloaded="reloaded"
                :disabled="idVytazenia != null"
              />
            </v-col>
            <v-col xl="3" lg="3" md="3">
              <check-box
                ref="profilPartneraVKZ"
                label="Profil partnera v KZ"
                dataId="liw_filip__wiz_kontaktna_osoba__btn_ma_profil_kz"
                :idZastupcu="pripad.idZastupcu"
                :disabled="idVytazenia != null"
              />
            </v-col>
          </v-row>
          <v-row class="mb-8">
            <v-col class="col-auto">
              <!-- Stara funkcionalita zakomentovana pre pripad ponuknutia filipa pre inu firmu -->
              <!-- <v-btn
                class="btn-primary"
                @click="sendOpRequest(email, telefon, zastupca.zahranicnaOsoba)"
                :disabled="nahratOpDisabled || !email || !telefon || sendingRequest"
              >
                Nahrať {{ zastupca.zahranicnaOsoba ? 'doklad' : 'OP' }} nájomcom
              </v-btn>
              <v-dialog
                v-model="dialog"
                overlay-color="#000"
                overlay-opacity="0.66"
                persistent
                max-width="500"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="btn-secondary ml-5"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="nahratOpDisabled"
                  >
                    Nahrať {{ zastupca.zahranicnaOsoba ? 'doklad' : 'OP' }}
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="d-flex justify-space-between">
                    Nahrajte prosím {{ zastupca.zahranicnaOsoba ? 'doklad' : 'občiansky preukaz' }}
                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <upload-area
                      ref="refuploadarea"
                      @uploaded="() => afterOpUploaded()"
                    ></upload-area>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="btn-secondary ml-5"
                      @click="dialog = false"
                      :disabled="uloadujemData"
                    >
                      Späť
                    </v-btn>
                    <v-btn class="btn-primary" @click="dmsSave()" :disabled="uloadujemData">
                      <v-icon left> mdi-upload-outline </v-icon>
                      Nahrať
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog> -->
              <v-btn
                class="btn-primary"
                @click="sendIdentityTB()"
                :disabled="sendingRequest || idVytazenia != null"
              >
                Odoslať Identity TB
              </v-btn>
              <v-btn
                v-if="nahratOpBtn.visible"
                class="btn-primary ml-5"
                @click="confirmAndSendOp()"
                :disabled="nahratOpBtn.disabled || sendingRequest || idVytazenia != null"
              >
                Nahrať {{ zastupca.zahranicnaOsoba ? 'doklad' : 'OP' }}
              </v-btn>
              <v-btn
                v-show="odfotitOpBtn.visible"
                class="btn-primary ml-5"
                @click="confirmAndOpenSendOpMobilDialog()"
                :disabled="odfotitOpBtn.disabled || sendingRequest || idVytazenia != null"
              >
                Odfotiť {{ zastupca.zahranicnaOsoba ? 'doklad' : 'OP' }} cez MT
              </v-btn>
              <v-dialog
                v-model="dialog"
                overlay-color="#000"
                overlay-opacity="0.66"
                persistent
                max-width="500"
              >
                <v-card>
                  <v-card-title class="d-flex justify-space-between">
                    Zadajte tel. číslo pre nahratie
                    {{ zastupca.zahranicnaOsoba ? 'dokladu' : 'občianského preukazu' }}
                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <text-box
                      ref="opTelCislo"
                      :rules="[telefonneCisloRule]"
                      label="Zadajte tel. číslo"
                      placeholder="+421"
                      required
                      @input="val => (opTelefon = val)"
                      textOnFocus="+421"
                      :removeCharacters="/[^+\d]/g"
                      :isPhoneNumber="true"
                      :cache="false"
                    ></text-box>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="btn-secondary ml-5" @click="dialog = false"> Späť </v-btn>
                    <v-btn class="btn-primary" @click="sendOpMobil()"> Odoslať </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-btn
                class="btn-secondary ml-5"
                v-on:click="zadatOpManualne = !zadatOpManualne"
                :disabled="idVytazenia != null"
              >
                Zadať {{ zastupca.zahranicnaOsoba ? 'doklad' : 'OP' }} manuálne
              </v-btn>
            </v-col>
            <v-col class="col-auto">
              <check-box
                ref="fyzickeOverenie"
                label="Fyzické overenie"
                dataId="liw_filip__wiz_kontaktna_osoba__btn_fyzicke_overenie"
                :idZastupcu="pripad.idZastupcu"
                @input="v => (fyzickeOverenie = v)"
                style="margin-top: -12px"
                :disabled="idVytazenia != null"
              ></check-box>
            </v-col>
          </v-row>

          <!-- ########### -->
          <!-- Manualne OP -->
          <!-- ########### -->

          <div v-show="zadatOpManualne">
            <v-row class="mt-8">
              <v-col xl="4" lg="4" md="4">
                <dynamic-combo
                  ref="titul"
                  label="Titul"
                  data-id="liw_filip__wiz_kontaktna_osoba__cb_tituly"
                  :idZastupcu="pripad.idZastupcu"
                  :parentReloaded="reloaded"
                  :disabled="idVytazenia != null"
                ></dynamic-combo>
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <dynamic-combo
                  ref="pohlavie"
                  label="Pohlavie"
                  :idZastupcu="pripad.idZastupcu"
                  @input="val => (zastupca.pohlavie = val)"
                  data-id="liw_filip__wiz_kontaktna_osoba__cb_pohlavia"
                  @valueChanged="() => this.$refs.pohlavieCard.loadData()"
                  @dataLoaded="() => this.$refs.pohlavieCard.loadData()"
                  :disabled="idVytazenia != null"
                ></dynamic-combo>
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="4" lg="4" md="4">
                <text-box
                  ref="zastupcaMeno"
                  label="Meno"
                  :idZastupcu="pripad.idZastupcu"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_meno"
                  placeholder="Meno kontaktnej osoby"
                  @valueChanged="() => this.$refs.zastupcaMenoCard.loadData()"
                  @input="v => (this.zastupcaMeno = v)"
                  @dataLoaded="() => this.$refs.zastupcaMenoCard.loadData()"
                  :disabled="idVytazenia != null"
                ></text-box>
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <text-box
                  ref="zastupcaPriezvisko"
                  @valueChanged="
                    () => {
                      this.$refs.zastupcaPriezviskoCard.loadData();
                      if (this.$refs.rodnePriezvisko) this.$refs.rodnePriezvisko.loadData();
                    }
                  "
                  @input="v => (this.zastupcaPriezvisko = v)"
                  @dataLoaded="
                    () => {
                      this.$refs.zastupcaPriezviskoCard.loadData();
                      if (this.$refs.rodnePriezvisko) this.$refs.rodnePriezvisko.loadData();
                    }
                  "
                  label="Priezvisko"
                  :idZastupcu="pripad.idZastupcu"
                  placeholder="Priezvisko kontaktnej osoby"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_priezvisko"
                  :disabled="idVytazenia != null"
                ></text-box>
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <DatePicker
                  ref="datumNarodenia"
                  :idZastupcu="pripad.idZastupcu"
                  label="Dátum narodenia"
                  placeholder="DD/MM/YYYY"
                  @valueChanged="() => this.$refs.datumNarodeniaCard.loadData()"
                  @dataLoaded="() => this.$refs.datumNarodeniaCard.loadData()"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_datum_narodenia"
                  :disabled="idVytazenia != null"
                ></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="4" lg="4" md="4">
                <dynamic-combo
                  ref="obcianstvo"
                  label="Štátne občianstvo"
                  :staticLabel="
                    zastupca.zahranicnaOsoba ? 'Štátna príslušnosť' : 'Štátne občianstvo'
                  "
                  :idZastupcu="pripad.idZastupcu"
                  @valueChanged="() => this.$refs.obcianstvoCard.loadData()"
                  @dataLoaded="() => this.$refs.obcianstvoCard.loadData()"
                  @input="val => (zastupca.obcianstvo = val)"
                  :parentReloaded="reloaded"
                  :rules="[v => statnaPrislusnostRule(v)]"
                  data-id="liw_filip__wiz_kontaktna_osoba__cb_statne_obcianstvo"
                  :disabled="idVytazenia != null"
                ></dynamic-combo>
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <text-box
                  ref="rodneCislo"
                  @valueChanged="
                    () => {
                      this.$refs.rodneCisloCard.loadData();
                      this.OnRodneCisloValueChanged();
                      this.$refs.fyzickeOverenie.loadData();
                    }
                  "
                  @input="val => (zastupca.rodneCislo = val)"
                  :rodneCislo="!zastupca.zahranicnaOsoba"
                  :idZastupcu="pripad.idZastupcu"
                  label="Rodné číslo"
                  :staticLabel="zastupca.zahranicnaOsoba ? 'Identifikačné číslo' : 'Rodné číslo'"
                  :placeholder="zastupca.zahranicnaOsoba ? 'idč. bez /' : 'rdč. bez /'"
                  @dataLoaded="() => this.$refs.rodneCisloCard.loadData()"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_rc"
                  :disabled="idVytazenia != null"
                >
                </text-box>
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="4" lg="4" md="4">
                <text-box
                  ref="cisloOp"
                  label="Číslo OP"
                  :staticLabel="zastupca.zahranicnaOsoba ? 'Číslo dokladu' : 'Číslo OP'"
                  :idZastupcu="pripad.idZastupcu"
                  placeholder="XX123456"
                  @valueChanged="() => this.$refs.cisloOpCard.loadData()"
                  @dataLoaded="() => this.$refs.cisloOpCard.loadData()"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_cislo_op"
                  :parentReloaded="reloaded"
                  :maxValue="14"
                  :disabled="idVytazenia != null"
                ></text-box>
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <DatePicker
                  ref="datumVydania"
                  :staticLabel="zastupca.zahranicnaOsoba ? 'Platnosť od' : 'Dátum vydania'"
                  placeholder="DD/MM/YYYY"
                  :idZastupcu="pripad.idZastupcu"
                  @valueChanged="
                    val => {
                      this.$refs.datumVydaniaCard.loadData();
                      this.setDatumPlatnostiPlus10(val);
                    }
                  "
                  @dataLoaded="() => this.$refs.datumVydaniaCard.loadData()"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_datum_vydania_op"
                  :parentReloaded="reloaded"
                  :disabled="idVytazenia != null"
                >
                </DatePicker>
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <DatePicker
                  ref="datumPlatnosti"
                  label="Dátum platnosti"
                  :staticLabel="zastupca.zahranicnaOsoba ? 'Platnosť do' : 'Dátum platnosti'"
                  placeholder="DD/MM/YYYY"
                  :idZastupcu="pripad.idZastupcu"
                  @valueChanged="() => this.$refs.datumPlatnostiCard.loadData()"
                  @dataLoaded="() => this.$refs.datumPlatnostiCard.loadData()"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_datum_platnosti_op"
                  :parentReloaded="reloaded"
                  :disabled="idVytazenia != null"
                >
                </DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="4" lg="4" md="4">
                <combo-box
                  ref="mesto"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_mesto"
                  :idZastupcu="pripad.idZastupcu"
                  :parentReloaded="reloaded"
                  label="Mesto/obec"
                  :items="mestoSearchData"
                  :class="{ readonly: zastupca.readonly }"
                  :loading="mestoSearchLoading.value"
                  clearable
                  naked
                  :outerSearch="true"
                  returnObject
                  @valueChanged="
                    () => {
                      this.$refs.mestoCard.loadData();
                      cityOnChange();
                    }
                  "
                  @input="val => (mesto = val)"
                  @search="
                    val => {
                      searchCity(val, 3);
                    }
                  "
                  @dataLoaded="
                    val => {
                      mesto = val;
                      searchCity(val, 3, 0, true).then(() => $refs.ulica.loadData());
                      this.$refs.mestoCard.loadData();
                    }
                  "
                  :disabled="idVytazenia != null"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <combo-box
                  ref="ulica"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_ulica_cislo"
                  :idZastupcu="pripad.idZastupcu"
                  :parentReloaded="reloaded"
                  label="Ulica"
                  :items="ulicaSearchData"
                  :class="{ readonly: zastupca.readonly }"
                  :loading="ulicaSearchLoading.value"
                  clearable
                  naked
                  :outerSearch="true"
                  returnObject
                  @input="val => (ulica = val)"
                  @dataLoaded="
                    val => {
                      ulica = val;
                      searchStreets(val, 3, 0, true).then(() => $refs.cisloDomu.loadData());
                      this.$refs.ulicaCard.loadData();
                    }
                  "
                  @search="
                    val => {
                      searchStreets(val, 3);
                    }
                  "
                  @valueChanged="
                    () => {
                      this.$refs.ulicaCard.loadData();
                      streetOnChange();
                    }
                  "
                  :disabled="idVytazenia != null"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <combo-box
                  ref="cisloDomu"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_cislo_domu"
                  :idZastupcu="pripad.idZastupcu"
                  :parentReloaded="reloaded"
                  label="Číslo domu"
                  :items="cislo_domuSearchData"
                  :class="{ readonly: zastupca.readonly }"
                  :loading="cislo_domuSearchLoading.value"
                  clearable
                  naked
                  :outerSearch="true"
                  returnObject
                  @input="val => (cislo_domu = val)"
                  @dataLoaded="
                    val => {
                      cislo_domu = val;
                      searchAddresses(val, 0, 0, true)
                        .then(() => $refs.psc.loadData())
                        .then(() => (adresyInitialized = true));
                      $refs.cisloDomuCard.loadData();
                    }
                  "
                  @search="
                    val => {
                      searchAddresses(val, 0);
                    }
                  "
                  @valueChanged="
                    () => {
                      $refs.cisloDomuCard.loadData();
                      addressOnChange();
                    }
                  "
                  :disabled="idVytazenia != null"
                />
              </v-col>
              <v-col xl="4" lg="4" md="4">
                <combo-box
                  ref="psc"
                  data-id="liw_filip__wiz_kontaktna_osoba__txt_psc"
                  :idZastupcu="pripad.idZastupcu"
                  :parentReloaded="reloaded"
                  label="PSČ"
                  :items="pscSearchData"
                  :class="{ readonly: zastupca.readonly }"
                  :loading="pscSearchLoading.value"
                  clearable
                  naked
                  :outerSearch="true"
                  returnObject
                  :rules="[pscRule]"
                  @input="val => (psc = val)"
                  @dataLoaded="
                    val => {
                      psc = val;
                      searchZIP(val, 0, 0, true);
                      $refs.pscCard.loadData();
                    }
                  "
                  @search="
                    val => {
                      searchZIP(val, 0);
                    }
                  "
                  @valueChanged="
                    () => {
                      $refs.pscCard.loadData();
                    }
                  "
                  :disabled="idVytazenia != null"
                />
              </v-col>
            </v-row>
          </div>

          <!-- ########### -->
          <!-- OP karticka -->
          <!-- ########### -->
          <div v-show="!zadatOpManualne">
            <div class="d-flex op-cards">
              <!-- ######################## -->
              <!-- OP karticka ZADNA strana -->
              <!-- ######################## -->
              <v-card class="op-back pb-0">
                <v-row>
                  <v-col cols="6">
                    <div :class="{ readonly: zastupca.readonly }">
                      <combo-box
                        ref="mestoCard"
                        data-id="liw_filip__wiz_kontaktna_osoba__txt_mesto"
                        :idZastupcu="pripad.idZastupcu"
                        :parentReloaded="reloaded"
                        label="Mesto/obec"
                        :items="mestoSearchData"
                        :readonly="zastupca.readonly"
                        :class="{ readonly: zastupca.readonly }"
                        :loading="mestoSearchLoading.value"
                        clearable
                        naked
                        :outerSearch="true"
                        returnObject
                        @input="val => (mesto = val)"
                        @search="
                          val => {
                            searchCity(val, 3);
                          }
                        "
                        @valueChanged="
                          () => {
                            this.$refs.mesto.loadData();
                          }
                        "
                        :disabled="idVytazenia != null"
                      />
                    </div>
                  </v-col>
                  <v-col cols="6"></v-col>
                  <v-col cols="6">
                    <div :class="{ readonly: zastupca.readonly }">
                      <combo-box
                        ref="ulicaCard"
                        data-id="liw_filip__wiz_kontaktna_osoba__txt_ulica_cislo"
                        :idZastupcu="pripad.idZastupcu"
                        :parentReloaded="reloaded"
                        label="Ulica"
                        :items="ulicaSearchData"
                        :readonly="zastupca.readonly"
                        :class="{ readonly: zastupca.readonly }"
                        :loading="ulicaSearchLoading.value"
                        clearable
                        naked
                        :outerSearch="true"
                        returnObject
                        @input="val => (ulica = val)"
                        @search="
                          val => {
                            searchStreets(val, 3);
                          }
                        "
                        @valueChanged="
                          () => {
                            this.$refs.ulica.loadData();
                          }
                        "
                        :disabled="idVytazenia != null"
                      />
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div :class="{ readonly: zastupca.readonly }">
                      <combo-box
                        ref="cisloDomuCard"
                        data-id="liw_filip__wiz_kontaktna_osoba__txt_cislo_domu"
                        :idZastupcu="pripad.idZastupcu"
                        :parentReloaded="reloaded"
                        label="Číslo domu"
                        :items="cislo_domuSearchData"
                        :readonly="zastupca.readonly"
                        :class="{ readonly: zastupca.readonly }"
                        :loading="cislo_domuSearchLoading.value"
                        clearable
                        naked
                        :outerSearch="true"
                        returnObject
                        @input="val => (cislo_domu = val)"
                        @search="
                          val => {
                            searchAddresses(val, 0);
                          }
                        "
                        @valueChanged="
                          () => {
                            $refs.cisloDomu.loadData();
                          }
                        "
                        :disabled="idVytazenia != null"
                      />
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div :class="{ readonly: zastupca.readonly }">
                      <combo-box
                        ref="pscCard"
                        data-id="liw_filip__wiz_kontaktna_osoba__txt_psc"
                        :idZastupcu="pripad.idZastupcu"
                        :parentReloaded="reloaded"
                        label="PSČ"
                        :items="pscSearchData"
                        :readonly="zastupca.readonly"
                        :class="{ readonly: zastupca.readonly }"
                        :loading="pscSearchLoading.value"
                        clearable
                        naked
                        :outerSearch="true"
                        returnObject
                        :rules="[pscRule]"
                        @input="val => (psc = val)"
                        @search="
                          val => {
                            searchZIP(val, 0);
                          }
                        "
                        @valueChange="
                          () => {
                            $refs.psc.loadData();
                          }
                        "
                        :disabled="idVytazenia != null"
                      />
                    </div>
                  </v-col>
                  <v-col cols="6"></v-col>
                  <v-col cols="6">
                    <text-box
                      ref="miestoNarodenia"
                      dataId="liw_filip__wiz_kontaktna_osoba__txt_miesto_narodenia"
                      :idZastupcu="pripad.idZastupcu"
                      :parentReloaded="reloaded"
                      label="Miesto narodenia"
                      :readonly="zastupca.readonly"
                      :class="{ readonly: zastupca.readonly }"
                      naked
                      :disabled="idVytazenia != null"
                    ></text-box>
                  </v-col>
                  <v-col cols="6">
                    <text-box
                      v-if="!zastupca.zahranicnaOsoba"
                      ref="rodnePriezvisko"
                      dataId="liw_filip__wiz_kontaktna_osoba__txt_rodne_priezvisko"
                      label="Rodné priezvisko"
                      :idZastupcu="pripad.idZastupcu"
                      :readonly="zastupca.readonly"
                      :class="{ readonly: zastupca.readonly }"
                      naked
                      :disabled="idVytazenia != null"
                    ></text-box>
                    <text-box
                      v-else
                      :key="zastupca.zahranicnaOsoba"
                      naked
                      class="readonly"
                      readonly
                      :disabled="idVytazenia != null"
                    ></text-box>
                  </v-col>
                  <v-col cols="6">
                    <text-box
                      ref="osobitneZaznamy"
                      dataId="liw_filip__wiz_kontaktna_osoba__txt_osobitne_zaznamy"
                      :idZastupcu="pripad.idZastupcu"
                      :parentReloaded="reloaded"
                      label="Osobité záznamy"
                      :readonly="zastupca.readonly"
                      :class="{ readonly: zastupca.readonly }"
                      naked
                      :disabled="idVytazenia != null"
                    ></text-box>
                  </v-col>
                </v-row>
                <v-tooltip top :close-delay="0" :open-delay="200">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="btn-icon btn-op-edit"
                      v-on="on"
                      :class="{
                        'btn-terciary': zastupca.readonly,
                        'btn-secondary': !zastupca.readonly,
                      }"
                      @click="editOp(zastupca)"
                      :disabled="idVytazenia != null"
                    >
                      <v-icon>
                        {{ zastupca.readonly ? 'mdi-pencil-outline' : 'mdi-check' }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ zastupca.readonly ? 'Editovať' : 'Potvrdiť' }}</span>
                </v-tooltip>
              </v-card>

              <!-- ######################## -->
              <!-- OP karticka PREDNA strana -->
              <!-- ######################## -->
              <v-card class="op order-first pb-0 px-25px">
                <div class="d-flex">
                  <v-img class="mt-30px" :width="123" :height="163" :src="opImage"></v-img>
                  <div class="pl-34px">
                    <v-row>
                      <v-col cols="7">
                        <text-box
                          ref="zastupcaPriezviskoCard"
                          @input="v => (this.zastupcaPriezvisko = v)"
                          @valueChanged="() => this.$refs.zastupcaPriezvisko.loadData()"
                          :idZastupcu="pripad.idZastupcu"
                          data-id="liw_filip__wiz_kontaktna_osoba__txt_priezvisko"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          naked
                          :disabled="idVytazenia != null"
                        ></text-box>
                      </v-col>
                      <v-col cols="5">
                        <date-picker
                          ref="datumNarodeniaCard"
                          @valueChanged="() => this.$refs.datumNarodenia.loadData()"
                          dataId="liw_filip__wiz_kontaktna_osoba__txt_datum_narodenia"
                          :idZastupcu="pripad.idZastupcu"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          no-icon
                          text-only
                          naked
                          :disabled="idVytazenia != null"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="7">
                        <text-box
                          ref="zastupcaMenoCard"
                          @input="v => (this.zastupcaMeno = v)"
                          @valueChanged="() => this.$refs.zastupcaMeno.loadData()"
                          dataId="liw_filip__wiz_kontaktna_osoba__txt_meno"
                          :idZastupcu="pripad.idZastupcu"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          naked
                          :disabled="idVytazenia != null"
                        ></text-box>
                      </v-col>
                      <v-col cols="5">
                        <text-box
                          ref="rodneCisloCard"
                          @input="val => (zastupca.rodneCislo = val)"
                          @valueChanged="
                            () => {
                              this.$refs.rodneCislo.loadData();
                              this.OnRodneCisloValueChanged();
                              this.$refs.fyzickeOverenie.loadData();
                            }
                          "
                          data-id="liw_filip__wiz_kontaktna_osoba__txt_rc"
                          :staticLabel="
                            zastupca.zahranicnaOsoba ? 'Identifikačné číslo' : 'Rodné číslo'
                          "
                          :idZastupcu="pripad.idZastupcu"
                          :rodneCislo="!zastupca.zahranicnaOsoba"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          naked
                          :disabled="idVytazenia != null"
                        >
                        </text-box>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="pr-0">
                        <dynamic-combo
                          ref="obcianstvoCard"
                          @input="val => (zastupca.obcianstvo = val)"
                          @valueChanged="() => this.$refs.obcianstvo.loadData()"
                          data-id="liw_filip__wiz_kontaktna_osoba__cb_statne_obcianstvo"
                          :staticLabel="
                            zastupca.zahranicnaOsoba ? 'Štátna príslušnosť' : 'Štátne občianstvo'
                          "
                          :rules="[v => statnaPrislusnostRule(v)]"
                          :idZastupcu="pripad.idZastupcu"
                          :parentReloaded="reloaded"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          naked
                          :disabled="idVytazenia != null"
                        ></dynamic-combo>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="5">
                        <dynamic-combo
                          ref="pohlavieCard"
                          @input="val => (zastupca.pohlavie = val)"
                          @valueChanged="() => this.$refs.pohlavie.loadData()"
                          data-id="liw_filip__wiz_kontaktna_osoba__cb_pohlavia"
                          :idZastupcu="pripad.idZastupcu"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          naked
                          :disabled="idVytazenia != null"
                        ></dynamic-combo>
                      </v-col>
                      <v-col cols="2"></v-col>
                      <v-col cols="5">
                        <date-picker
                          ref="datumPlatnostiCard"
                          @valueChanged="() => this.$refs.datumPlatnosti.loadData()"
                          dataId="liw_filip__wiz_kontaktna_osoba__txt_datum_platnosti_op"
                          :staticLabel="
                            zastupca.zahranicnaOsoba ? 'Platnosť do' : 'Dátum platnosti'
                          "
                          :idZastupcu="pripad.idZastupcu"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          no-icon
                          text-only
                          naked
                          :disabled="idVytazenia != null"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="5">
                        <text-box
                          ref="cisloOpCard"
                          @valueChanged="() => this.$refs.cisloOp.loadData()"
                          dataId="liw_filip__wiz_kontaktna_osoba__txt_cislo_op"
                          :staticLabel="zastupca.zahranicnaOsoba ? 'Číslo dokladu' : 'Číslo OP'"
                          :idZastupcu="pripad.idZastupcu"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          naked
                          :maxValue="14"
                          :disabled="idVytazenia != null"
                        ></text-box>
                      </v-col>
                      <v-col cols="2"></v-col>
                      <v-col cols="5">
                        <date-picker
                          ref="datumVydaniaCard"
                          @valueChanged="
                            val => {
                              this.$refs.datumVydania.loadData();
                              this.setDatumPlatnostiPlus10(val);
                            }
                          "
                          dataId="liw_filip__wiz_kontaktna_osoba__txt_datum_vydania_op"
                          :idZastupcu="pripad.idZastupcu"
                          :readonly="zastupca.readonly"
                          :class="{ readonly: zastupca.readonly }"
                          no-icon
                          text-only
                          naked
                          :disabled="idVytazenia != null"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </v-card>
      </v-form>
      <message-box
        v-model="checkNajomcaMessage.open"
        :title="checkNajomcaMessage.title"
        :text="checkNajomcaMessage.text"
        persistent
        hide-cancel
      />
      <message-box
        v-model="checkOpUploadedMessage.open"
        :title="checkOpUploadedMessage.title"
        :text="checkOpUploadedMessage.text"
        :action="checkOpUploadedMessage.action"
        :cancel="checkOpUploadedMessage.cancel"
        persistent
        yes-no
      />
    </v-container>
  </div>
</template>
<script>
import CheckBox from '../basic/CheckBox.vue';
import ComboBox from '../basic/ComboBox.vue';
import DynamicCombo from '../basic/DynamicCombo.vue';
import DynamicSearchCombo from '../basic/DynamicSearchCombo.vue';
import ButtonGroup from '../basic/ButtonGroup.vue';
import TextBox from '../basic/TextBox.vue';
import DatePicker from '../basic/DatePicker.vue';
import UploadArea from '../basic/UploadArea.vue';
import Ico from '../basic/Ico.vue';
import protectedAxios from '../../auth/axios';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { wizardMixin } from '../../mixins/wizardMixin.js';
import MessageBox from '../basic/MessageBox.vue';
import { eventBus } from '../../main.js';
import UvodForma from '../uvod/UvodForma.vue';
import UvodBanner from '../uvod/UvodBanner.vue';

export default {
  mixins: [wizardMixin],
  components: {
    TextBox,
    DynamicCombo,
    DynamicSearchCombo,
    CheckBox,
    UploadArea,
    ButtonGroup,
    DatePicker,
    Ico,
    MessageBox,
    ComboBox,
    UvodForma,
    UvodBanner,
  },
  data() {
    return {
      formaPodn: null,
      defaultMessage: {
        text: 'Na predschválenie ponuky je potrebné vyplniť polia nájomcu.',
        isError: false,
      },
      dialog: false,
      zadatOpManualne: false,
      icoObj: null,
      vytvorenieZakaznikaTimeout: null,
      lastIco: null,
      icoEnabled: true,
      icoFopPoZadane: false,
      podnikaNaRc: null,
      idStatutar: null,
      idFunkcie: null,
      sendingRequest: false,
      email: null,
      telefon: null,
      zastupcaMeno: null,
      zastupcaPriezvisko: null,
      zastupca: {
        rodneCislo: null,
        readonly: true,
        opUploaded: false,
        pohlavie: null,
        obcianstvo: null,
        zahranicnaOsoba: null,
      },
      najomcaChecked: false,
      checkNajomcaMessage: {
        open: false,
        title: '',
        text: '',
      },
      checkOpUploadedMessage: {
        open: false,
        title: 'Občiansky preukaz',
        text:
          'Pre zadané rodné číslo nie je nahratý Občiansky preukaz. Rodné číslo nebude uložené. Prajete si pokračovať bez uloženia rod. čísla?',
      },
      uloadujemData: false,
      jeKlonovanyRozpracovany: false,

      ulica: null,
      ulicaSearchData: [],
      ulicaSearchLoading: { value: false },
      psc: null,
      pscSearchData: [],
      pscSearchLoading: { value: false },
      mesto: null,
      mestoSearchData: [],
      mestoSearchLoading: { value: false },
      cislo_domu: null,
      cislo_domuSearchData: [],
      cislo_domuSearchLoading: { value: false },
      searchTimeout: {
        cityTimeout: null,
        streetTimeout: null,
        addressTimeout: null,
        zipTimeout: null,
      },
      adresyInitialized: false,
      fyzickeOverenie: false,
      opTelefon: null,
      nahratOpBtn: {
        visible: false,
        disabled: false,
      },
      odfotitOpBtn: {
        visible: false,
        disabled: false,
      },
      vytazenieStateTimer: null,
      idVytazenia: null,
    };
  },
  computed: {
    ...mapState(['wizardFormControls', 'pripad']),
    ...mapGetters([
      'pripadFromPostParams',
      'vytvaranieZakaznikaPrebieha',
      'pravoNaAdresnuPonuku',
      'isMobile',
    ]),
    opImage() {
      const img = this.zastupca.pohlavie === 2 ? 'op_female.png' : 'op_male.png';
      return require(`../../assets/img/${img}`);
    },
    nahratOpDisabled() {
      return (
        (this.icoFopPoZadane == false && this.formaPodn < 3 && !this.podnikaNaRc) ||
        (this.formaPodn === 3 && !this.zastupca.rodneCislo) ||
        !this.pravoNaAdresnuPonuku
      );
    },
  },
  watch: {
    icoObj(val, oldVal) {
      this.icoFopPoZadane = !!val;

      if (val && oldVal && val.ico === oldVal.ico) {
        this.vytvorZakaznika();
      } else {
        this.stopniVytvorenieZakaznika();
      }
    },
    mesto(newVal, oldVal) {
      if (!this.adresyInitialized) return;
      // console.log('mesto', newVal, oldVal);
      const v = newVal && newVal.displayMember ? newVal.displayMember : newVal;
      const o = oldVal && oldVal.displayMember ? oldVal.displayMember : oldVal;

      if (v !== o) this.$refs.mesto.setValue(v);
    },
    ulica(newVal, oldVal) {
      if (!this.adresyInitialized) return;
      // console.log('ulica', newVal, oldVal);
      const v = newVal && newVal.displayMember ? newVal.displayMember : newVal;
      const o = oldVal && oldVal.displayMember ? oldVal.displayMember : oldVal;

      if (v !== o) this.$refs.ulica.setValue(v);
    },
    cislo_domu(newVal, oldVal) {
      if (!this.adresyInitialized) return;
      // console.log('cisloDomu', newVal, oldVal);
      const v = newVal && newVal.displayMember ? newVal.displayMember : newVal;
      const o = oldVal && oldVal.displayMember ? oldVal.displayMember : oldVal;

      if (v !== o) this.$refs.cisloDomu.setValue(v);
    },
    psc(newVal, oldVal) {
      if (!this.adresyInitialized) return;
      // console.log('psc', newVal, oldVal);
      const v = newVal && newVal.displayMember ? newVal.displayMember : newVal;
      const o = oldVal && oldVal.displayMember ? oldVal.displayMember : oldVal;

      if (v !== o) this.$refs.psc.setValue(v);
    },
    idVytazenia(val) {
      if (val) {
        this.startGetVytazenieStateTask();
      }
    },
  },
  methods: {
    ...mapMutations([
      'setPripadFromPostParams',
      'setVytvaranieZakaznikaPrebieha',
      'setLoadingDialog',
      'openDialog',
      'closeDialog',
    ]),
    openOpConfirmation(onContinue) {
      this.openDialog({
        width: 500,
        persistent: true,
        header: 'Upozornenie',
        text:
          '<span class="gs100 f16">Vyťažením občianskeho preukazu sa vytvára účet v Klientskej zóne. Prosím skontroluje zadaný email a telefónne číslo na zástupcovi.</span>',
        closeIcon: {
          value: true,
        },
        secondaryBtn: {
          text: 'Zrušiť',
          func: () => this.closeDialog(),
        },
        primaryBtn: {
          text: 'Pokračovať',
          func: () => {
            this.closeDialog();
            onContinue();
          },
        },
      });
    },
    confirmAndSendOp() {
      this.openOpConfirmation(() => this.sendOp());
    },
    confirmAndOpenSendOpMobilDialog() {
      this.openOpConfirmation(() => {
        this.dialog = true;
      });
    },
    overKlon() {
      //console.log(this.jeKlonovanyRozpracovany);

      if (this.jeKlonovanyRozpracovany) this.vytvorZakaznika();
    },
    editOp(zastupca) {
      zastupca.readonly = !zastupca.readonly;
    },
    //beforeStep vola PripadyWizard.vue po validacii formulara. Musi vratit promise !!!
    async beforeStep() {
      this.closeEditOp();
      let prom = Promise.resolve();

      await protectedAxios.get(`/pripady/${this.pripad.newId}/check-op-uploaded`).then(res => {
        this.zastupca.opUploaded = res.data;
      });
      if (!this.zastupca.opUploaded && !!this.zastupca.rodneCislo) {
        prom = new Promise((res, rej) => {
          this.checkOpUploadedMessage.title = !this.zastupca.zahranicnaOsoba
            ? 'Občiansky preukaz'
            : 'Doklad';
          this.checkOpUploadedMessage.text = !this.zastupca.zahranicnaOsoba
            ? 'Pre zadané rodné číslo nie je nahratý Občiansky preukaz. Rodné číslo nebude uložené. Prajete si pokračovať bez uloženia rod. čísla?'
            : 'Pre zadané identifikačné číslo nie je nahratý doklad. Identifikačné číslo nebude uložené. Prajete si pokračovať bez uloženia identifikačného čísla?';

          this.checkOpUploadedMessage.open = true;
          this.checkOpUploadedMessage.action = () => {
            if (!this.zastupca.opUploaded) {
              this.$refs.rodneCisloCard.clear();
            }
            res(true);
          }
          this.checkOpUploadedMessage.cancel = () => {
            rej();
            }
        });
      }

      let prom2 = Promise.resolve(true);

      if (!this.zastupca.opUploaded && this.fyzickeOverenie) {
        prom.then(() => {
            prom2 = new Promise((res, rej) => {
              this.checkOpUploadedMessage.title = !this.zastupca.zahranicnaOsoba
                ? 'Občiansky preukaz'
                : 'Doklad';
              this.checkOpUploadedMessage.text = !this.zastupca.zahranicnaOsoba
                ? 'Pre označené fyzické overenie nie je nahratý Občiansky preukaz. Fyzické overenie nebude uložené. Prajete si pokračovať bez uloženia fyzického overenia?'
                : 'Pre označené fyzické overenie nie je nahratý doklad. Fyzické overenie nebude uložené. Prajete si pokračovať bez uloženia fyzického overenia?';

              this.checkOpUploadedMessage.open = true;
              this.checkOpUploadedMessage.action = () => {
                this.$refs.fyzickeOverenie.update(false);
                res(true);
              };
              this.checkOpUploadedMessage.cancel = () => {
                rej();
              }
            });
        });
      }

      if (!this.najomcaChecked) {
        prom.then(() => {
          prom2
            .then(() => protectedAxios.get('/pripady/check-najomca'))
            .then(res => {
              if (res.data) {
                this.checkNajomcaMessage.title = res.data;
                this.checkNajomcaMessage.open = true;
                this.najomcaChecked = true;
              }
            });
        });
      }

      prom.then(() => {
        prom2.then(() => {
          this.posliMemorandum();
        });
      });

      if (this.somethingGetDirty) {
        return prom.then(() => {
          return prom2.then(() => {
            this.setValid(
              false,
              'vytvorenieZastupca',
              'Na pozadí prebieha vytváranie a overenie zástupcu',
              true
            );

            return protectedAxios
              .post(`controls/createzastupca`, null, {
                headers: {
                  'Content-Type': 'application/json',
                },
              })
              .then(res => {
                this.setValid(true, 'vytvorenieZastupca', this.defaultMessage.text, false);

                if (res.data && res.data.length > 0 && res.data.find(i => i.ko === 1)) {
                  this.setValid(
                    false,
                    'najomcaIco',
                    'Pre daného zákazníka nie je možné vytvoriť ponuku.',
                    false,
                    true
                  );
                  return false;
                } else
                  this.setValid(
                    true,
                    'najomcaIco',
                    this.defaultMessage.text,
                    false,
                    this.defaultMessage.isError
                  );
                if (this.fyzickeOverenie && !this.$refs.fyzickeOverenie.jeDisabled) this.setFyzickeOverenie();
                this.clearDirty();
                return true;
              })
              .catch(() => this.zobrazErrorHlasku());
          }).catch(() => false);
        }).catch(() => false);
      } else {
        return prom.then(() => {
          return prom2.then(() => true).catch(() => false);
        }).catch(() => false);
      }
    },
    OnLoadFormaPodn(isLoad) {
      this.$refs.idFunkcie.loadData().then(() => {
        if (!isLoad || this.formaPodn != 1) this.nastavPrazdnuFunkciu();
      });

      if (this.formaPodn === 1) {
        this.LoadIco();

        this.$refs.kuv.loadData();
        this.$refs.jeKonatel.loadData();
      }

      if (this.formaPodn === 2) {
        this.$refs.podnikaNaRc.loadData().then(() => {
          if (!this.podnikaNaRc) {
            this.LoadIco();
          }
        });

        this.$refs.kuv.loadData();
        this.$refs.jeKonatel.loadData();
      }
      this.$refs.idStatutar.loadData().then(() => {
        this.$refs.titul.loadData();
        this.$refs.pohlavie.loadData();
        this.$refs.datumNarodenia.loadData();
        this.$refs.miestoNarodenia.loadData();
        this.$refs.osobitneZaznamy.loadData();
        this.$refs.zahrOsoba.loadData();
        this.$refs.zastupcaMeno.loadData();
        this.$refs.zastupcaPriezvisko.loadData().then(() => {
          this.$refs.rodnePriezvisko.loadData();
        });
        this.$refs.zastupcaPriezviskoCard.loadData();
        Promise.all([this.$refs.email.loadData(), this.$refs.telCislo.loadData()]).then(async _ => {
          this.getOPBtn();
        });

        this.$refs.obcianstvo.loadData();
        this.$refs.cisloOp.loadData().then(() => {
          this.$refs.rodneCislo.loadData().then(()=>{
            this.$refs.profilPartneraVKZ.loadData();
          });
        });
        this.$refs.fyzickeOverenie.loadData();
        this.$refs.datumVydania.loadData();
        this.$refs.datumPlatnosti.loadData();
        this.$refs.mesto.loadData().then(() => {
          this.$refs.ulica.loadData().then(() => {
            this.$refs.cisloDomu.loadData();
          });
          this.$refs.psc.loadData();
        });
      });
    },
    OnRodneCisloValueChanged() {
      this.$refs.datumNarodenia.loadData();
      this.$refs.pohlavieCard.loadData();
      this.$refs.pohlavie.loadData();
      this.$refs.profilPartneraVKZ.loadData();

      if (!this.zastupca.opUploaded) {
        this.wizardMessage = {
          text:
            'Po zadaní rodného čísla je potrebné nahrať občiansky preukaz ak občiansky preukaz nebude nahratý , rodné číslo sa neuloží.',
          isError: false,
        };
      }

      if (this.$refs.ico) this.$refs.ico.loadData();
    },
    OnPodnikaNaRcValueChanged() {
      Promise.all([
        this.$refs.zastupcaMeno.loadData(),
        this.$refs.zastupcaPriezvisko.loadData(),
        this.$refs.zastupcaPriezviskoCard.loadData(),
        this.$refs.email.loadData(),
        this.$refs.telCislo.loadData(),
      ]).then(_ => {
        this.getOPBtn();
      });
      this.$refs.obcianstvo.loadData();
      this.$refs.cisloOp.loadData();
      this.$refs.datumVydania.loadData();
      this.$refs.datumPlatnosti.loadData();
      this.$refs.mesto.loadData().then(() => {
        this.$refs.ulica.loadData().then(() => {
          this.$refs.cisloDomu.loadData();
        });
        this.$refs.psc.loadData();
      });

      this.nastavPrazdnuFunkciu();

      if (!this.podnikaNaRc) {
        this.LoadIco();
      }
    },
    OnFormaPodnValueChanged() {
      clearTimeout(this.vytvorenieZakaznikaTimeout);
      this.OnLoadFormaPodn();
    },
    LoadIco() {
      this.$refs.ico.loadData().then(() => {
        if (this.icoObj) {
          this.lastIco = this.icoObj.ico;
        }
      });
    },
    reload() {
      this.$refs.rodneCislo.loadData().then(() => {
        this.$refs.profilPartneraVKZ.loadData();
        this.$refs.datumNarodenia.loadData();
        this.$refs.pohlavieCard.loadData();
        this.$refs.pohlavie.loadData();
      });
      this.$refs.formaPodn.loadData().then(() => {
        this.$refs.idStatutar.loadData();
        this.OnLoadFormaPodn(true);
      });
    },
    stopniVytvorenieZakaznika() {
      clearTimeout(this.vytvorenieZakaznikaTimeout);
    },
    zobrazErrorHlasku() {
      console.error('Nastala chyba pri vytvarani zakaznika.');
      this.icoEnabled = true;
      this.setVytvaranieZakaznikaPrebieha(false);
      this.setValid(true, 'najomcaIco', 'Nastala chyba pri vytváraní zákazníka.', false, true);
    },
    vytvorZakaznika() {
      if (!this.icoObj) return;
      if (this.lastIco === this.icoObj.ico && !this.jeKlonovanyRozpracovany) return;

      clearTimeout(this.vytvorenieZakaznikaTimeout);

      this.vytvorenieZakaznikaTimeout = setTimeout(() => {
        this.lastIco = this.icoObj.ico;
        this.icoEnabled = false;
        this.setVytvaranieZakaznikaPrebieha(true);
        this.icoFopPoZadane = false;
        this.setValid(false, 'najomcaIco', 'Na pozadí prebieha vytvorenie zákazníka', true);

        protectedAxios
          .post(`controls/createzaujemca`, null, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(res => {
            this.icoEnabled = true;
            this.setVytvaranieZakaznikaPrebieha(false);

            if (res.data && res.data.length > 0 && res.data.find(i => i.ko === 1)) {
              this.setValid(
                false,
                'najomcaIco',
                'Pre daného zákazníka nie je možné vytvoriť ponuku.',
                false,
                true
              );
            } else {
              this.setValid(
                true,
                'najomcaIco',
                this.defaultMessage.text,
                false,
                this.defaultMessage.isError
              );

              this.icoFopPoZadane = true;
              this.$refs.idStatutar.loadData().then(() => {
                this.$refs.idFunkcie.loadData();
                this.$refs.kuv.loadData();
                this.$refs.jeKonatel.loadData();
                this.$refs.titul.loadData();
                this.$refs.pohlavie.loadData();
                this.$refs.datumNarodenia.loadData();
                this.$refs.miestoNarodenia.loadData();
                this.$refs.osobitneZaznamy.loadData();
                this.$refs.zahrOsoba.loadData();
                this.$refs.zastupcaMeno.loadData();
                this.$refs.zastupcaPriezvisko.loadData().then(() => {
                  this.$refs.rodnePriezvisko.loadData();
                });
                this.$refs.zastupcaPriezviskoCard.loadData();
                Promise.all([this.$refs.email.loadData(), this.$refs.telCislo.loadData()]).then(
                  _ => {
                    this.getOPBtn();
                  }
                );
                this.$refs.obcianstvo.loadData();
                this.$refs.cisloOp.loadData().then(() => {
                  this.$refs.rodneCislo.loadData().then(()=>{
                    this.$refs.profilPartneraVKZ.loadData();
                  });
                });
                this.$refs.fyzickeOverenie.loadData();
                this.$refs.datumVydania.loadData();
                this.$refs.datumPlatnosti.loadData();
                this.$refs.mesto.loadData().then(() => {
                  this.$refs.ulica.loadData().then(() => {
                    this.$refs.cisloDomu.loadData();
                  });
                  this.$refs.psc.loadData();
                });
              });
            }
          })
          .catch(e => {
            if (e.response?.data?.code === 51000) {
              this.lastIco = null;
              this.icoObj = null;
              this.icoEnabled = true;
              this.setVytvaranieZakaznikaPrebieha(false);
              this.setValid(
                true,
                'najomcaIco',
                this.defaultMessage.text,
                false,
                this.defaultMessage.isError
              );
            } else {
              this.zobrazErrorHlasku();
            }
          });
      }, 500);
    },
    telefonneCisloRule(v) {
      if (!v) return true;
      if (!/^\+/.test(v)) return 'Telefónne číslo musí začínať znakom +';
      if (v.length < 10) return 'Nie je vyplnené telefónne číslo';
      if (!/^(\+)[0-9]*$/.exec(v)) return 'Telefónne číslo može obsahovať iba číslice';
      return true;
    },
    pscRule(v) {
      if (this.zastupca.obcianstvo !== 1) return true;
      if (!v?.valueMember) return true;
      if (!/^[0-9]*$/.exec(v?.valueMember)) return 'PSČ smie obsahovať iba čísla';
      if (v?.valueMember.length != 5) return 'Nesprávne PSČ';

      return true;
    },
    statnaPrislusnostRule(v) {
      if (!v) return true;
      if (!!this.zastupca.zahranicnaOsoba && v === 1)
        return 'Zahraničná osoba ≠ Slovenská republika';
      return true;
    },
    dmsSave() {
      this.$refs.refuploadarea.filesSaved(() => {
        this.uloadujemData = false;
        this.dialog = false;
        this.wizardMessage = this.defaultMessage;
      });
      this.$refs.refuploadarea.filesNotSaved(() => {
        this.uloadujemData = false;
      });
      this.uloadujemData = true;
      if (this.zastupcaMeno) {
        this.$refs.refuploadarea.save(
          this.zastupca.zahranicnaOsoba ? 600 : 128,
          this.zastupca.zahranicnaOsoba
            ? `Povolenie na pobyt z IS LIW Filip pre zástupcu: ${this.zastupcaMeno} ${this.zastupcaPriezvisko}`
            : `Občiansky z IS LIW Filip pre zástupcu: ${this.zastupcaMeno} ${this.zastupcaPriezvisko}`
        );
      } else {
        this.$refs.refuploadarea.save(
          this.zastupca.zahranicnaOsoba ? 600 : 128,
          this.zastupca.zahranicnaOsoba
            ? `Povolenie na pobyt z IS LIW Filip`
            : `Občiansky z IS LIW Filip`
        );
      }
    },
    sendOpRequest(email, mobil, zahranicny) {
      this.sendingRequest = true;
      this.setValid(true, 'sendOpRequest', 'Odosiela sa email nájomcovi', true);

      protectedAxios
        .get('/otp/sendOpRequest', {
          params: {
            newId: this.pripad.newId,
            email: email,
            mobil: mobil,
            menoPriezvisko: this.zastupcaMeno + ' ' + this.zastupcaPriezvisko,
            zahranicny: zahranicny,
          },
        })
        .then(res => {
          eventBus.$emit(res.data.error ? 'snack-error' : 'snack-info', res.data.text);
          this.sendingRequest = false;
          this.zastupca.opUploaded = true;

          this.setValid(true, 'sendOpRequest', this.defaultMessage.text, false);
        })
        .catch(e => {
          eventBus.$emit('snack-error', 'Pri odosielaní emailu nájomcovi nastala chyba.');
          this.sendingRequest = false;

          this.setValid(true, 'sendOpRequest', this.defaultMessage.text, false);
        });
    },
    posliMemorandum() {
      protectedAxios
        .post('/pripady/sendmemo')
        .then(res => {
          if (res.data > 0)
            eventBus.$emit(
              'snack-info',
              `Na email ${this.email} bolo úspešne zaslané memorandum GDPR.`
            );
        })
        .catch(e => {
          eventBus.$emit('snack-error', 'Pri odosielaní memoranda nastala chyba.');
        });
    },
    closeEditOp() {
      if (!this.zastupca.readonly) this.zastupca.readonly = true;
    },
    nastavPrazdnuFunkciu() {
      if (this.formaPodn !== 1) {
        this.$refs.idFunkcie.setValue(0); //0 - prazdna funkcia
      } else if (this.idFunkcie || this.idFunkcie === 0) this.$refs.idFunkcie.setValue(null);
    },
    afterOpUploaded() {
      this.zastupca.opUploaded = true;
    },
    setDatumPlatnostiPlus10(val) {
      if (this.zastupca.zahranicnaOsoba) return;

      let newDate = null;
      if (val) {
        newDate = `${parseInt(val.substring(0, 4)) + 10}-${val.substring(4, 6)}-${val.substring(
          6,
          8
        )}`;
      }
      this.$refs.datumPlatnosti.setValue(newDate);
    },

    //adresy logic
    searchCity(val, searchMinCharacters = 3, delay = 500, isInit = false) {
      if ((val === this.mesto || (this.mesto && val === this.mesto?.valueMember)) && !isInit)
        return Promise.resolve();
      this.mestoSearchData = [];
      if (!val || val.length < searchMinCharacters) {
        return Promise.resolve();
      }

      clearTimeout(this.searchTimeout.cityTimeout);
      this.mestoSearchLoading.value = true;

      return new Promise(
        (parentRes, _) =>
          (this.searchTimeout.cityTimeout = setTimeout(() => {
            protectedAxios.get(`cis/address/cities?query=${val ?? ''}`).then(res => {
              if (res.data && res.data.length > 0) {
                this.mestoSearchData.push(...res.data);

                if (isInit) this.mesto = this.mestoSearchData[0];
              }
              this.mestoSearchLoading.value = false;
              parentRes();
            });
          }, delay))
      );
    },
    searchStreets(val, delay = 500, searchMinCharacters = 3, isInit = false) {
      if (!this.mesto?.id && !this.mesto?.valueMember) return Promise.resolve();
      let cityId = 0;
      if (this.mesto?.id) cityId = this.mesto?.id;
      if ((val === this.ulica || val === this.ulica?.valueMember) && !isInit)
        return Promise.resolve();
      this.ulicaSearchData = [];
      if (!val || val.length < searchMinCharacters) {
        return Promise.resolve();
      }
      clearTimeout(this.searchTimeout.streetTimeout);
      this.ulicaSearchLoading.value = true;
      if (!val || val.length < searchMinCharacters) {
        return Promise.resolve();
      }
      return new Promise(
        (parentRes, _) =>
          (this.searchTimeout.streetTimeout = setTimeout(() => {
            protectedAxios
              .get(
                `cis/address/streets?cityId=${cityId}&&cityName=${
                  this.mesto?.valueMember ?? ''
                }&query=${val ?? ''}`
              )
              .then(res => {
                if (res.data && res.data.length > 0) {
                  this.ulicaSearchData.push(...res.data);

                  if (isInit) this.ulica = this.ulicaSearchData[0];
                }
                this.ulicaSearchLoading.value = false;

                parentRes();
              });
          }, delay))
      );
    },
    searchAddresses(val, searchMinCharacters = 3, delay = 500, isInit = false) {
      if (!this.ulica?.id) return Promise.resolve();
      if ((val === this.cislo_domu || val === this.cislo_domu?.valueMember) && !isInit)
        return Promise.resolve();
      this.cislo_domuSearchData = [];
      if (!val || val.length < searchMinCharacters) {
        return Promise.resolve();
      }
      clearTimeout(this.searchTimeout.addressTimeout);
      this.cislo_domuSearchLoading.value = true;

      return new Promise(
        (parentRes, _) =>
          (this.searchTimeout.addressTimeout = setTimeout(() => {
            protectedAxios
              .get(`cis/address/addresses?streetId=${this.ulica?.id ?? ''}&query=${val ?? ''}`)
              .then(res => {
                if (res.data && res.data.length > 0) {
                  this.cislo_domuSearchData.push(...res.data);

                  if (isInit) this.cislo_domu = this.cislo_domuSearchData[0];
                }
                this.cislo_domuSearchLoading.value = false;

                parentRes();
              });
          }, delay))
      );
    },
    searchZIP(val, delay = 500, isInit = false) {
      if ((!val && !isInit) || !this.cislo_domu) return Promise.resolve();

      if (!this.cislo_domu?.id && !this.mesto?.valueMember) return Promise.resolve();
      if ((val === this.psc || val === this.psc?.valueMember) && !isInit) return Promise.resolve();
      let addressId = 0;
      if (this.cislo_domu?.id) addressId = this.cislo_domu?.id;
      this.pscSearchData = [];

      clearTimeout(this.searchTimeout.pscTimeout);
      this.pscSearchLoading.value = true;

      return new Promise(
        (parentRes, _) =>
          (this.searchTimeout.pscTimeout = setTimeout(() => {
            protectedAxios
              .get(
                `cis/address/zip?addressId=${addressId}&cityName=${
                  this.mesto?.valueMember ?? ''
                }&query=${val ?? ''}`
              )
              .then(res => {
                if (res.data && res.data.length > 0) {
                  this.pscSearchData.push(...res.data);
                  if (isInit || this.pscSearchData.legth === 1) this.psc = this.pscSearchData[0];
                }
                this.pscSearchLoading.value = false;
                parentRes();
              });
          }, delay))
      );
    },
    cityOnChange(val) {
      this.ulica = null;
      this.ulicaSearchData = [];
      this.cislo_domu = null;
      this.cislo_domuSearchData = [];
      this.psc = null;
      this.pscSearchData = [];
    },
    streetOnChange(val) {
      this.cislo_domu = null;
      this.cislo_domuSearchData = [];
      this.psc = null;
      this.pscSearchData = [];
    },
    addressOnChange(val) {
      if (!this.cislo_domu) this.psc = null;
      this.searchZIP(null, 0, true);
    },
    loadStatutar() {
      this.$refs.idStatutar
        .loadData()
        .then(() => {
          this.OnLoadFormaPodn(true);
          this.$refs.titul.loadData();
          this.$refs.pohlavie.loadData();
          this.$refs.datumNarodenia.loadData();
          this.$refs.obcianstvo.loadData();
          this.$refs.rodneCislo.loadData().then(()=>{
            this.$refs.profilPartneraVKZ.loadData();
          });
          this.$refs.cisloOp.loadData();
          this.$refs.miestoNarodenia.loadData();
          this.$refs.datumVydania.loadData().then(() => {
            this.$refs.datumPlatnosti.loadData();
          });
          this.$refs.mesto.loadData().then(() => {
            this.$refs.ulica.loadData().then(() => {
              this.$refs.cisloDomu.loadData().then(() => {
                this.$refs.psc.loadData();
              });
            });
          });
          this.$refs.osobitneZaznamy.loadData();
        })
        .then(() => {
          this.$refs.fyzickeOverenie.loadData();
        });
    },
    OnMenoValueChanged() {
      this.$refs.zastupcaMeno.loadData();
      this.getOPBtn();
    },
    OnPriezviskoValueChanged() {
      this.$refs.zastupcaPriezvisko.loadData();
      this.getOPBtn();
    },
    OnEmailValueChanged() {
      this.$refs.fyzickeOverenie.loadData();
      this.$refs.profilPartneraVKZ.loadData();
      this.getOPBtn();
    },
    getOPBtn() {
      this.getNahratOpBtn();
      this.getOdfotitOpBtn();
    },
    async getNahratOpBtn() {
      const viewObjectId = 'liw_filip__wiz_kontaktna_osoba__btn_nahrat_op';
      return protectedAxios
        .get(
          `controls?ViewObjectId=${viewObjectId}&NewId=${
            this.pripad?.newId
          }&CisloPredmetu=${''}&CisloPlz=${encodeURIComponent('')}&IdZastupcu=1`
        )
        .then(res => {
          this.nahratOpBtn = {
            visible: !!res.data.config.is_visible,
            disabled: !res.data.config.is_enabled,
          };
        })
        .catch(e => {
          console.error(e);
        });
    },
    async getOdfotitOpBtn() {
      const viewObjectId = 'liw_filip__wiz_kontaktna_osoba__btn_odfotit_op';
      return protectedAxios
        .get(
          `controls?ViewObjectId=${viewObjectId}&NewId=${
            this.pripad?.newId
          }&CisloPredmetu=${''}&CisloPlz=${encodeURIComponent('')}&IdZastupcu=1`
        )
        .then(res => {
          this.odfotitOpBtn = {
            visible: !!res.data.config.is_visible,
            disabled: !res.data.config.is_enabled,
          };
        })
        .catch(e => {
          console.error(e);
        });
    },
    async sendIdentityTB() {
      return await protectedAxios.post(`/pripady/${this.pripad.newId}/send-identityTB`).then(()=>{
        eventBus.$emit('snack-info', 'Emailová notifikácia bude odoslaná po uložení obchodného prípadu.');
      }).catch(e => {
        eventBus.$emit('snack-error', e);
        console.error(e);
      });
    },
    async sendOp() {
      var obchMeno = null;
      var ico = null;
      const kuv = this.$refs?.kuv?.currentValue == 1;
      const statutar = this.$refs?.jeKonatel?.currentValue == 1;
      const zahranicnaOsoba = this.$refs?.zahrOsoba?.currentValue == 1;
      const idFunkcie = this.idFunkcie ?? 0;
      const podnikaNaRc = this.podnikaNaRc == 1;
      const returnUrl = window.location.href;
      if (this.formaPodn === 1 || (this.formaPodn === 2 && !this.podnikaNaRc)) {
        if (this.icoObj) {
          obchMeno = this.icoObj.nazov;
          ico = this.icoObj.ico;
        } else {
          eventBus.$emit('snack-error', 'Vyplnte prosím IČO a Obchodné meno');
          return;
        }
      }
      return await protectedAxios
        .post(`/pripady/${this.pripad.newId}/send-op`, {
          pageContext: 'Eclient_Wizard',
          email: this.email,
          telefon: this.telefon,
          obchMeno: obchMeno,
          ico: ico + "",
          idFormaPodnikania: this.formaPodn,
          idZastupcu: this.pripad.idZastupcu,
          kuv: kuv,
          statutar: statutar,
          zahranicnaOsoba: zahranicnaOsoba,
          idFunkcie: idFunkcie,
          podnikaNaRc: podnikaNaRc,
          physicalVerification: this.fyzickeOverenie == 1 ? true : false,
          returnUrl: returnUrl,
        })
        .then(res => {
          if (res.data.error > 0) {
            eventBus.$emit('snack-error', res.data.errorText);
          } else {
            window.onbeforeunload = null;
            window.location.href = res.data.url;
          }
        })
        .catch(e => {
          eventBus.$emit('snack-error', e);
          console.error(e);
        });
    },
    async sendOpMobil() {
      var obchMeno = null;
      var ico = null;
      const kuv = this.$refs?.kuv?.currentValue == 1;
      const statutar = this.$refs?.jeKonatel?.currentValue == 1;
      const zahranicnaOsoba = this.$refs?.zahrOsoba?.currentValue == 1;
      const idFunkcie = this.idFunkcie ?? 0;
      const podnikaNaRc = this.podnikaNaRc == 1;
      const returnUrl = window.location.href;
      if (this.formaPodn === 1 || (this.formaPodn === 2 && !this.podnikaNaRc)) {
        if (this.icoObj) {
          obchMeno = this.icoObj.nazov;
          ico = this.icoObj.ico;
        } else {
          eventBus.$emit('snack-error', 'Vyplnte prosím IČO a Obchodné meno');
          return;
        }
      }
      this.setLoadingDialog({
        open: true,
        btext: 'Prebieha proces vyťažovania dokladu...',
        utext: 'Dokončite proces na mobilnom zariadení.',
      });
      return await protectedAxios
        .post(`/pripady/${this.pripad.newId}/send-op-mobil`, {
          pageContext: 'Eclient_Wizard',
          email: this.email,
          telefon: this.telefon,
          telefonSendLink: this.opTelefon,
          obchMeno: obchMeno,
          ico: ico + "",
          idFormaPodnikania: this.formaPodn,
          idZastupcu: this.pripad.idZastupcu,
          kuv: kuv,
          statutar: statutar,
          zahranicnaOsoba: zahranicnaOsoba,
          idFunkcie: idFunkcie,
          podnikaNaRc: podnikaNaRc,
          physicalVerification: this.fyzickeOverenie == 1 ? true : false,
          returnUrl: returnUrl,
        })
        .then(res => {
          this.dialog = false;
          this.opTelefon = null;
          if (res.data.error > 0) {
            eventBus.$emit('snack-error', res.data.errorText);
            this.setLoadingDialog();
          } else {
            this.idVytazenia = res.data.idVytazenia;
          }
        })
        .catch(e => {
          eventBus.$emit('snack-error', e);
          console.error(e);
          this.setLoadingDialog();
        });
    },

    startGetVytazenieStateTask() {
      this.vytazenieStateTimer = setInterval(() => {
        this.getVytazenie();
      }, 3000);
    },

    async getVytazenie() {
      return await protectedAxios
        .get(`/pripady/${this.pripad.newId}/vytazenie?idVytazenia=${this.idVytazenia}`)
        .then(res => {
          if (res.data.status == 'success') {
            clearInterval(this.vytazenieStateTimer);
            this.setLoadingDialog();
            this.idVytazenia = null;
            this.reload();
          }
          if (res.data.status == 'in_progress') {
            this.setLoadingDialog({
              open: true,
              btext: 'Prebieha proces vyťažovania dokladu...',
              utext: 'Dokončite proces na mobilnom zariadení.',
            });
            return;
          }
          if (res.data.status == 'fail') {
            clearInterval(this.vytazenieStateTimer);
            eventBus.$emit('snack-error', 'Nepodarilo sa spracovať údaje z OP. Skúste to neskôr.');
            this.setLoadingDialog();
            this.idVytazenia = null;
          }
        })
        .catch(e => {
          console.error(e);
          clearInterval(this.vytazenieStateTimer);
          this.idVytazenia = null;
        });
    },
    async setFyzickeOverenie() {
      return await protectedAxios
        .post(`/pripady/${this.pripad.newId}/fyzicke-overenie?idZastupcu=1`)
        .then(res => {
          if (res.data.error > 0) {
            eventBus.$emit('snack-error', res.data.errorText);
            return Promise.reject(false);
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
  },
  async mounted() {
    await protectedAxios
      .get(`/pripady/${this.pripad.newId}/check-op-uploaded`)
      .then(res => (this.zastupca.opUploaded = res.data));

    await protectedAxios
      .get(`/pripady/${this.pripad.newId}/je-klonovany-rozpracovany`)
      .then(res => {
        this.jeKlonovanyRozpracovany = res.data;
      });

    this.$on('formControlsLoaded', () => {
      if (this.pripadFromPostParams) {
        this.setPripadFromPostParams(null);
        if (this.icoObj) {
          this.lastIco = null;
          this.vytvorZakaznika(true);
        }
        if (this.email) this.posliMemorandum();
      }
    });

    //kontrola ci ma KO kriteria
    if (this.$route.name === 'editPripad') {
      await protectedAxios.get(`/pripady/${this.pripad.newId}/has-ko`).then(res => {
        if (res.data === 1) {
          this.setValid(
            false,
            'ko-kriterium',
            'Pre daného zákazníka nie je možné vytvoriť ponuku.',
            false,
            true
          );
        }
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.vytazenieStateTimer);
  },
};
</script>
